import {DAY} from '../../../shared/services/referral.service';

export const PER_PAGE = 10;

export function fmtDate(t: number): string {
    return new Date(t).toLocaleDateString('en-IN', {day: 'numeric', month: 'short', year: 'numeric'});
}

export function ago(t: number): string {
    const d = Math.floor((Date.now() - t) / DAY);
    return d <= 0 ? 'Today' : d === 1 ? 'Yesterday' : d + ' days ago';
}

export function cap(s: string): string {
    return s ? s[0].toUpperCase() + s.slice(1) : s;
}
